import React, {useEffect,useState} from 'react'
import axios from 'axios';
import { Link } from 'react-router-dom';



const Getsections = () => {
 

  useEffect( () => {

   
  

   
 
    allproduct(localStorage.getItem("b_id"));
   

}, []); 





const [apartsec, setApartsec] = useState([]);








const [loading, setLoading] = useState(false);

const allproduct = async (b_id) => {
  setLoading(true);

  try {
   

  
 
    
    axios.get('https://tower.future-swift.com/api/apartsec.php?b_id='+b_id)
    .then(res => {
      
      setApartsec(res.data.productlist.productdata);
      setLoading(false);
    })
  } catch (error) { throw error;}    
 
}


return (
  
  <div >

<h1>...</h1>
  
 
    {loading ? (
      <div className="loader-container">
      
      <h4 style={{position:'absolute', top:'37%', color:'lightblue'}}>FUTURE SWIFT...</h4>
        <div class="spinner">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>
        </div>
      ) : ( 


        <div className='container2'>
        <div className="list" style={{marginTop:90,marginBottom:50}}>
          <h1>ادارة مخططات البرج</h1>
  <div className="container1">


  {apartsec.map((item,index)=>(
    <Link to={`/apart_des/${item.as_id}/${item.apart_num}`} className="apartdes1">

    <div className="imglink2" href="">
            

                
           
              </div>
              
              <p style={{width:'95px',fontSize:'15px'}} className='title'><b>({item.apart_num})</b>مخطط</p> 

              </Link>
 
 

 
))}
</div>
 </div>
</div>
      )}
  </div>
  
)
  }

export default Getsections;









